import { CascadeSelectDesignTokens } from '@primeuix/themes/types/cascadeselect';
import { SM_SIZE_TOKENS } from './sm-size.tokens';

export const CASCADESELECT_STYLES: CascadeSelectDesignTokens = {
  root: {
    sm: SM_SIZE_TOKENS,
  },
  css: () => `
    .p-cascadeselect-sm .p-cascadeselect-label {
        line-height: 0.9375rem; /* 15px */
    }

    .p-cascadeselect-overlay .p-cascadeselect-option {
        font-size: 0.8125rem; /* 13px */
    }

    .p-cascadeselect-overlay .p-cascadeselect-list-container {
        max-height: 24rem;
        overflow-y: auto;
    }

    .p-cascadeselect-overlay .p-cascadeselect-list {
        width: 10rem;
    }

    .p-cascadeselect-overlay .p-cascadeselect-option-list {
        max-height: 20rem;
        overflow-y: auto;
    }`,
};
